<template>
  <a-modal :open="visible" :title="title" @ok="ok" @cancel="cancel" width="40%">
    <a-form
      ref="formRef"
      :model="formData"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <form-input
        label="系统code"
        name="parentName"
        disabled
        v-model:value="systemCode"
      ></form-input>
      <form-input
        label="页面名称"
        name="menuName"
        v-model:value="formData.menuName"
      ></form-input>
      <form-input
        label="页面英文"
        name="menuNameEn"
        v-model:value="formData.menuNameEn"
      ></form-input>
      <form-select
        label="类型"
        name="menuType"
        v-model:value="formData.menuType"
      >
        <a-select-option
          :value="item.id"
          :key="item.id"
          v-for="item in typeList"
        >
          {{ item.name }}
        </a-select-option>
      </form-select>
      <form-input
        v-if="formData.menuType === 2"
        label="路径"
        name="menuPath"
        v-model:value="formData.menuPath"
      ></form-input>
      <a-form-item label="上传图标">
        <Upload @change="change"></Upload>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { message } from 'ant-design-vue'
import { inject, toRefs, reactive, ref } from 'vue'
import { menu_operate_post } from 'server/modules/351.js'
export default {
  setup() {
    const state = inject('state')
    const menusState = inject('menusState')
    const formRef = ref()
    const alertState = reactive({
      typeList: [
        {
          name: '目录',
          id: 1
        },
        {
          name: '菜单',
          id: 2
        }
      ],
      rules: {
        menuName: [
          {
            required: true,
            message: '必填',
            trigger: 'blur'
          }
        ],
        menuNameEn: [
          {
            required: true,
            message: '必填',
            trigger: 'blur'
          }
        ],
        menuType: [
          { required: true, message: '必填', trigger: 'blur', type: 'number' }
        ],
        menuPath: [{ required: true, message: '必填', trigger: 'blur' }]
      },
      cancel() {
        const { setAttrs, setEmpty } = menusState
        setAttrs('visible', false)
        setEmpty()
      },
      ok: async () => {
        formRef.value
          .validate()
          .then(() => {
            alertState.add()
          })
          .catch(error => {
            console.log('error', error)
          })
      },
      // 新增地址
      add: async () => {
        const { formData } = menusState
        delete formData.menuCode
        const { success, retInfo } = await menu_operate_post(
          formData
        ).catch(() => {})
        if (success) {
          alertState.cancel()
          menusState.queryMenuList()
          // state.changePage(1)
          message.info(retInfo)
        } else {
          message.error(retInfo)
        }
      },
      change: info => {
        const { formData } = menusState
        formData.menuIcon = info.fileList[0].response.data
      }
    })
    return {
      formRef,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      ...toRefs(alertState),
      ...toRefs(state),
      ...toRefs(menusState)
    }
  }
}
</script>
